// ADD ACTIONS HERE
export const MONITOR_ACTIONS = {
  SET_SESSION_MESSAGE: 'MONITOR/SET_SESSION_MESSAGE',
  CLOSE_SESSION_MESSAGE: 'MONITOR/CLOSE_SESSION_MESSAGE',
  CLOSE_ERROR: 'MONITOR/CLOSE_ERROR',
  CLOSE_SUCCESS_INFO: 'MONITOR/CLOSE_SUCCESS_INFO',
};
export const USER_ACTION = {
  LOGIN_REQUEST: 'AUTH/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'AUTH/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'AUTH/LOGIN_FAILURE',
  LOGIN_IS_LOADING: 'AUTH/LOGIN_IS_LOADING',

  SIGNIN_REQUEST: 'AUTH/SIGNIN_REQUEST',
  SIGNIN_SUCCESS: 'AUTH/SIGNIN_SUCCESS',
  SIGNIN_FAILURE: 'AUTH/SIGNIN_FAILURE',
  SIGNIN_IS_LOADING: 'AUTH/SIGNIN_IS_LOADING',

  PASSWORD_RESET_REQUEST: 'AUTH/PASSWORD_RESET_REQUEST',
  PASSWORD_RESET_SUCCESS: 'AUTH/PASSWORD_RESET_SUCCESS',
  PASSWORD_RESET_FAILURE: 'AUTH/PASSWORD_RESET_FAILURE',
  PASSWORD_RESET_IS_LOADING: 'AUTH/PASSWORD_RESET_IS_LOADING',

  PASSWORD_RESET_CONFIRM_REQUEST: 'AUTH/PASSWORD_RESET_CONFIRM_REQUEST',
  PASSWORD_RESET_CONFIRM_SUCCESS: 'AUTH/PASSWORD_RESET_CONFIRM_SUCCESS',
  PASSWORD_RESET_CONFIRM_FAILURE: 'AUTH/PASSWORD_RESET_CONFIRM_FAILURE',
  PASSWORD_RESET_CONFIRM_IS_LOADING: 'AUTH/PASSWORD_RESET_CONFIRM_IS_LOADING',

  SET_FORM_DATA: 'AUTH/SET_FORM_DATA',
  SET_USER_DATA: 'AUTH/SET_USER_DATA',
  SET_RESET_FORM_DATA: 'AUTH/SET_RESET_FORM_DATA',
  USER_LOGGED_IN: 'AUTH/USER_LOGGED_IN',
  USER_LOGGED_OUT: 'AUTH/USER_LOGGED_OUT',
};

export const APPLICATION_ACTION = {
  CONTACT_REQUEST: 'APP/CONTACT_REQUEST',
  CONTACT_SUCCESS: 'APP/CONTACT_SUCCESS',
  CONTACT_FAILURE: 'APP/CONTACT_FAILURE',
  CONTACT_IS_LOADING: 'APP/CONTACT_IS_LOADING',

  PUBLICTION_REQUEST: 'APP/PUBLICTION_REQUEST',
  PUBLICTION_SUCCESS: 'APP/PUBLICTION_SUCCESS',
  PUBLICTION_FAILURE: 'APP/PUBLICTION_FAILURE',
  PUBLICTION_IS_LOADING: 'APP/PUBLICTION_IS_LOADING',

  SET_CONTACT_FORM_DATA: 'APP/SET_CONTACT_FORM_DATA',
  SET_ADDITIONAL_INFORMATION: 'APP/SET_ADDITIONAL_INFORMATION',

  EVENT_REQUEST: 'APP/EVENT_REQUEST',
  EVENT_SUCCESS: 'APP/EVENT_SUCCESS',
  EVENT_FAILURE: 'APP/EVENT_FAILURE',
  EVENT_IS_LOADING: 'APP/EVENT_IS_LOADING',

  SUBSCRIBE_REQUEST: 'APP/SUBSCRIBE_REQUEST',
  SUBSCRIBE_SUCCESS: 'APP/SUBSCRIBE_SUCCESS',
  SUBSCRIBE_FAILURE: 'APP/SUBSCRIBE_FAILURE',
  SUBSCRIBE_IS_LOADING: 'APP/SUBSCRIBE_IS_LOADING',

  EVENTREG_REQUEST: 'APP/EVENTREG_REQUEST',
  EVENTREG_SUCCESS: 'APP/EVENTREG_SUCCESS',
  EVENTREG_FAILURE: 'APP/EVENTREG_FAILURE',
  EVENTREG_IS_LOADING: 'APP/EVENTREG_IS_LOADING',
};

export const PRODUCT_ACTION = {
  PRODUCT_REQUEST: 'PRODUCT/PRODUCT_REQUEST',
  PRODUCT_SUCCESS: 'PRODUCT/PRODUCT_SUCCESS',
  PRODUCT_FAILURE: 'PRODUCT/PRODUCT_FAILURE',
  PRODUCT_IS_LOADING: 'PRODUCT/PRODUCT_IS_LOADING',

  PRODUCTENQ_REQUEST: 'PRODUCT/PRODUCTENQ_REQUEST',
  PRODUCTENQ_SUCCESS: 'PRODUCT/PRODUCTENQ_SUCCESS',
  PRODUCTENQ_FAILURE: 'PRODUCT/PRODUCTENQ_FAILURE',
  PRODUCTENQ_IS_LOADING: 'PRODUCT/PRODUCTENQ_IS_LOADING',
};


